import { RequestConfig } from '~/common/services/requests/types/RequestConfig';
import { ActiveDashboardDeal } from '../../../types/requests';
import { InceptHeader } from '../../constants/InceptHeader';
import { ConstructGet } from '../../types/ConstructGet';
import { PaginatedResponse } from '../../types/PaginatedResponse';
import { PLUGIN_BASE_PATH } from '../constants/pluginBasePath';

export const getDashboardActiveDeals = (
  constructGet: ConstructGet,
  params?: RequestConfig['params'],
  definition?: string,
): Promise<PaginatedResponse<ActiveDashboardDeal[]> | undefined> =>
  constructGet<PaginatedResponse<ActiveDashboardDeal[]>>(
    `${PLUGIN_BASE_PATH}/active-deals`,
    {
      params,
      headers: definition
        ? { [InceptHeader.DefinitionName]: definition }
        : undefined,
    },
  );
